/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 12:31:42 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Create,
  required,
  SelectArrayInput,
  SimpleForm,
  TextInput,
  useQueryWithStore,
  useTranslate,
  usePermissions,
  Title,
} from 'react-admin';
import { FormHelperText } from '@material-ui/core';
import { localeCountryListInputs as styles } from 'styles';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';

const ErrorText = ({ basePath, classes, dataType }) => {
  const translate = useTranslate();
  return (
    <FormHelperText className={classes.helperText}>
      {translate('error.region.errorGettingData', {
        dataType,
      })}
    </FormHelperText>
  );
};

const RegionCreate = props => {
  const { permissions } = usePermissions();
  const classes = styles();

  const {
    loaded: countryLoaded,
    error: countryError,
    data: countryData,
  } = useQueryWithStore({
    type: 'getList',
    resource: 'Country',
    payload: {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'name', order: 'DESC' },
    },
  });

  const {
    loaded: localeLoaded,
    error: localeError,
    data: localeData,
  } = useQueryWithStore({
    type: 'getList',
    resource: 'Locale',
    payload: {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'name', order: 'DESC' },
    },
  });

  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <Create {...props}>
        <SimpleForm>
          <TextInput source="name" validate={required()} />
          <SelectArrayInput
            source="countries"
            disabled={!(countryLoaded && !countryError)}
            label={'resources.Region.fields.countries'}
            fullWidth
            options={{
              error: countryLoaded && countryError ? true : false,
            }}
            className={classes.input}
            helperText={!localeError ? true : false}
            validate={required()}
            choices={countryData}
          />
          {countryLoaded && countryError ? (
            <ErrorText classes={classes} dataType="countries" />
          ) : null}
          <SelectArrayInput
            source="locales"
            disabled={!(localeLoaded && !localeError)}
            label={'resources.Region.fields.locales'}
            fullWidth
            options={{
              error: localeLoaded && localeError ? true : false,
            }}
            className={classes.input}
            helperText={!localeError ? true : false}
            validate={required()}
            choices={localeData}
          />
          {localeLoaded && localeError ? (
            <ErrorText classes={classes} dataType="locales" />
          ) : null}
        </SimpleForm>
      </Create>
    </>
  ) : (
    <AccessDenied />
  );
};

export default RegionCreate;
